import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { PanelPage } from '../../components/pages/pages';
import OneClickButton from '../../components/form/button';
import DualList from '../../components/pages/DualList';
import Form from '../../components/form/form';
import { generateReport } from '../../app/store/actions/reports';
import FilterDefault from '../../components/filters/FilterDefault';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';

class ReportAdminGeneralSupplier extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (<>
          <i className="fas fa-home fa-fw m-t-10 m-r-5" />
          {' '}
          { I18n.t('BEE12' /* Início */) }
                </>),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE1389' /* Cadastros */) },
      { value: I18n.t('BEE14' /* Gerais */) },
      { value: I18n.t('BEE23' /* Fornecedores */), active: true },
    ];

    this.options = [
      {
        label: I18n.t('BEE82' /* Código */),
        value: 'code',
      }, {
        label: I18n.t('BEE84' /* Razão Social */),
        value: 'name',
      }, {
        label: I18n.t('BEE352' /* Nome Fantasia */),
        value: 'businessName',
      }, {
        label: I18n.t('BEE86' /* E-mail */),
        value: 'email',
      }, {
        label: I18n.t('BEE133' /* Telefone */),
        value: 'phone',
      }, {
        label: I18n.t('BEE4214' /* CPF / CNPJ */),
        value: 'cnpj',
      }, {
        label: I18n.t('BEE117' /* Inscrição Estadual */),
        value: 'stateRegistration',
      }, {
        label: I18n.t('BEE119' /* CEP */),
        value: 'postalCode',
      }, {
        label: I18n.t('BEE568' /* IBGE */),
        value: 'ibge',
      }, {
        label: I18n.t('BEE121' /* Rua */),
        value: 'street',
      }, {
        label: I18n.t('BEE123' /* Número */),
        value: 'number',
      }, {
        label: I18n.t('BEE125' /* Complemento */),
        value: 'complement',
      }, {
        label: I18n.t('BEE567' /* Distrito */),
        value: 'district',
      }, {
        label: I18n.t('BEE53' /* Cidade */),
        value: 'city',
      }, {
        label: I18n.t('BEE580' /* UF */),
        value: 'state',
      }, {
        label: I18n.t('BEE88' /* País */),
        value: 'country',
      }, {
        label: I18n.t('BEE135' /* Observação */),
        value: 'note',
      }, {
        label: I18n.t('BEE575' /* Usuário de criação */),
        value: 'createdUser',
      }, {
        label: I18n.t('BEE578' /* Data de criação */),
        value: 'createdAt',
      }, {
        label: I18n.t('BEE576' /* Usuário de alteração */),
        value: 'updatedUser',
      }, {
        label: I18n.t('BEE577' /* Data de alteração */),
        value: 'updatedAt',
      },

    ];

    this.state = {
      selected: [],
      codeFrom: '',
      codeTo: '',
      nameFrom: '',
      nameTo: '',
      businessNameFrom: '',
      businessNameTo: '',
      cityFrom: '',
      cityTo: '',
      stateFrom: '',
      stateTo: '',
    };
  }

  onChangeDualList = (selected) => {
    this.setState({ selected });
  };

  setValue = async (attr, value, label) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  onGenerateSpreadsheet = () => {
    const {
      selected,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      businessNameFrom,
      businessNameTo,
      cityFrom,
      cityTo,
      stateFrom,
      stateTo,
    } = this.state;
    const { location } = this.props;

    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));

    const filters = returnFiltersByRules([
      ['code', { type: 'between', value: [codeFrom, codeTo] }],
      ['name', { type: 'between', value: [nameFrom, nameTo] }],
      ['businessName', { type: 'between', value: [businessNameFrom, businessNameTo] }],
      ['city', { type: 'between', value: [cityFrom, cityTo] }],
      ['state', { type: 'between', value: [stateFrom, stateTo] }],
    ]);

    this.props.generateReport(
      I18n.t('BEE23' /* Fornecedores */).toLowerCase(),
      'xlsx',
      location.pathname,
      headers,
      filters,
    );
  };

  onGeneratePdf = () => {
    const {
      selected,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      businessNameFrom,
      businessNameTo,
      cityFrom,
      cityTo,
      stateFrom,
      stateTo,
    } = this.state;
    const { location } = this.props;

    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));

    const filters = returnFiltersByRules([
      ['code', { type: 'between', value: [codeFrom, codeTo] }],
      ['name', { type: 'between', value: [nameFrom, nameTo] }],
      ['businessName', { type: 'between', value: [businessNameFrom, businessNameTo] }],
      ['city', { type: 'between', value: [cityFrom, cityTo] }],
      ['state', { type: 'between', value: [stateFrom, stateTo] }],
    ]);

    this.props.generateReport(
      I18n.t('BEE23' /* Fornecedores */).toLowerCase(),
      'pdf',
      location.pathname,
      headers,
      filters,
    );
  };

  onSelectFilter = (newState) => this.setState({ ...newState });

  render() {
    const {
      selected,
      codeFrom,
      codeTo,
      nameFrom,
      nameTo,
      businessNameFrom,
      businessNameTo,
      cityFrom,
      cityTo,
      stateFrom,
      stateTo,
    } = this.state;

    const { location = {} } = this.props;

    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={`${I18n.t('BEE528' /* Relatório */)} - ${I18n.t('BEE23' /* Fornecedores */)}`}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault stateToSave={this.state} route={location.pathname} onSelectFilter={this.onSelectFilter} />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <DualList
              id="dualselect"
              options={this.options}
              selected={selected}
              onChange={this.onChangeDualList}
              preserveSelectOrder
              showOrderButtons
              showHeaderLabels
            />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  // Código
                  formContext.createInputRange(
                    { from: codeFrom, to: codeTo },
                    { from: 'codeFrom', to: 'codeTo' },
                    `${I18n.t('BEE82' /* Código */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  // Razao Social
                  formContext.createInputRange(
                    { from: nameFrom, to: nameTo },
                    { from: 'nameFrom', to: 'nameTo' },
                    `${I18n.t('BEE84' /* Razão Social */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                  // Nome Fantasia
                  formContext.createInputRange(
                    { from: businessNameFrom, to: businessNameTo },
                    { from: 'businessNameFrom', to: 'businessNameTo' },
                    `${I18n.t('BEE352' /* Nome Fantasia */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                  // Cidade
                  formContext.createInputRange(
                    { from: cityFrom, to: cityTo },
                    { from: 'cityFrom', to: 'cityTo' },
                    `${I18n.t('BEE53' /* Cidade */)}:`,
                    { from: '', to: 'Z'.repeat(100) },
                  ),
                  // Estado
                  formContext.createInputRange(
                    { from: stateFrom, to: stateTo },
                    { from: 'stateFrom', to: 'stateTo' },
                    `${I18n.t('BEE580' /* UF */)}:`,
                    { from: '', to: 'Z'.repeat(80) },
                  ),
                ])}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
        )}
        footerContent={(
          <>
            <OneClickButton
              type="button"
              style={{ width: 'auto', padding: 10 }}
              className="btn btn-primary p-5 m-5"
              onClick={this.onGenerateSpreadsheet}
            >
              {I18n.t('BEE544' /* Gerar Planilha */)}
            </OneClickButton>
            {
              // <button
              //  type="button"
              //  style={{ width: 'auto', padding: 10 }}
              //  className="btn btn-secondary p-5 m-5"
              //  onClick={this.onGeneratePdf}
              // >
              //  {I18n.t('BEE545' /* Gerar PDF */)}
              // </button>
            }
          </>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  generateReport: (nameDoc, type, route, columns, filters) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportAdminGeneralSupplier);
